import { render, staticRenderFns } from "./StaticPagesWrapper.vue?vue&type=template&id=225f754d&scoped=true&"
import script from "./StaticPagesWrapper.vue?vue&type=script&lang=ts&"
export * from "./StaticPagesWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225f754d",
  null
  
)

export default component.exports